import impressionStore from 'modules/report/stores/impression'
import integrationReportStore from 'modules/report/stores/integrationReport'
import lossesStore from 'modules/report/stores/losses'

const NO_ENTITY_NAME = 'N/A'

const ENTITY_RESOLVERS = {
  publisher: impressionStore.publisher,
  allocation: impressionStore.allocation,
  path: impressionStore.path,
  page: impressionStore.page,
  pathUserProfile: impressionStore.pathUserProfile,
  offer: impressionStore.offer,
  site: lossesStore.site,
  post: lossesStore.post,
  lander: lossesStore.post,
  integration: integrationReportStore.integration,
}

function normalizeTableData(data) {
  if (!data) return { children: [] }
  if (Array.isArray(data)) return { children: data }
  if (data.children) return data
  return { children: [data] }
}

function stripEntityIdPrefix(value, name) {
  if (!name || value === '' || value == null) return name

  const id = String(value)
  return name
    .replace(new RegExp(`^\\[#${id}\\]\\s*-\\s*`), '')
    .replace(new RegExp(`^\\[#${id}\\]\\s+`), '')
    .trim() || name
}

function getEntity(resolver, value) {
  if (!resolver?.objectsMapping || value === '' || value == null) return null

  return resolver.objectsMapping[value]
    ?? resolver.objectsMapping[String(value)]
    ?? resolver.objectsMapping[Number(value)]
}

function resolveRowName(node, key, resolvers) {
  const entity = getEntity(resolvers[key], node.value)

  if (entity?.label) return entity.label

  if (node.name) return stripEntityIdPrefix(node.value, node.name)

  if (resolvers[key] && (node.value === 0 || node.value === '0')) return NO_ENTITY_NAME

  return node.name
}

function assignRowMetadata(nodes, groupby, depth, resolvers, parent = null) {
  if (!nodes?.length) return

  nodes.forEach(node => {
    const key = node.key || groupby[Math.min(depth, groupby.length - 1)]

    node.key = key
    node.parent = parent

    const resolvedName = resolveRowName(node, key, resolvers)
    if (resolvedName) node.name = resolvedName

    delete node.formattedName

    if (node.children?.length) {
      assignRowMetadata(node.children, groupby, depth + 1, resolvers, node)
    }
  })
}

async function loadEntityResolvers(groupby = []) {
  const resolvers = groupby
    .filter(field => ENTITY_RESOLVERS[field])
    .map(field => ENTITY_RESOLVERS[field].fetchData())

  await Promise.all(resolvers)
  return ENTITY_RESOLVERS
}

export async function enrichCustomReportData(data, groupby = []) {
  const resolvers = await loadEntityResolvers(groupby)
  const root = normalizeTableData(data)

  if (groupby.length && root.children?.length) {
    assignRowMetadata(root.children, groupby, 0, resolvers)
  }

  return root
}
